export const USER_PROFILE_REQUEST = "User/UserProfileRequest";
export const USER_PROFILE_SUCCESS = "User/UserProfileSuccess";
export const USER_PROFILE_ERROR = "User/UserProfileError";